import React, { useState } from "react";
import dangerIconRed from "../../assets/images/icons/dangerIconRed.svg"; // Adjust the path as per your structure
import { ReactComponent as CloseIconBlackUniversal } from "../../assets/images/icons/CloseIconUniversalBlack.svg";

const SearchBar = ({
  value = "",
  onChange,
  placeholder = "Search...",
  className = "",
  error = "",
  label = "",
  helperText = "",
  id,
  autoFocus = false,
  name = "",
  mandatory = false,
  ...props
}) => {
  const [touched, setTouched] = useState(false);
  const [inputValue, setInputValue] = useState(value);
  const [errorText, setErrorText] = useState(error);

  const handleClearInput = (e) => {
    setInputValue("");
    if (onChange) onChange({ target: { name: id, value: "" } }); // Optional: Pass the cleared value to the parent
  };

  const handleInputChange = (e) => {
    setInputValue(e.target.value);
    if (onChange) onChange(e); // Optional: Pass the updated value to the parent
  };

  const handleInputBlur = () => {
    setTouched(true);
    if (!inputValue && inputValue !== 0) {
      setErrorText("Please Enter a search term");
    } else {
      setErrorText("");
    }
  };

  return (
    <div className={`flex flex-col mb-4 ${className}`} role="search">
      {label && (
        <label htmlFor={id} className="text-sm font-medium text-gray-700 mb-1" aria-label={label}>
          {label}
        </label>
      )}
      <div
        className={`flex items-center border rounded-md bg-white border-gray-300 ${
          mandatory && ((touched && !inputValue) || errorText)
            ? "border-red-500 focus:ring-red-500 focus:border-red-500"
            : "border-gray-300 focus:ring-blue-500 focus:border-blue-500"
        }`}
      >
        <input
          type="text"
          name={name}
          value={inputValue}
          onChange={handleInputChange}
          placeholder={placeholder}
          className={`px-3 py-2 w-full text-sm border-none`}
          id={id}
          aria-invalid={errorText ? "true" : "false"}
          aria-describedby={(helperText && touched && !inputValue) || errorText ? `${id}-helper` : undefined}
          {...props}
          onBlur={handleInputBlur}
          autoFocus={autoFocus}
        />
        {inputValue && (
          <button
            onClick={handleClearInput}
            className="px-2 py-1 ml-2 text-gray-500 focus:outline-none"
            aria-label="Clear search"
          >
            <CloseIconBlackUniversal className="w-[10px] h-[10px]" />
          </button>
        )}
      </div>
      {mandatory && helperText && ((touched && !inputValue) || errorText) && (
        <span
          id={`${id}-helper`}
          className="flex gap-1 items-center text-xs text-gray-500 ms-1 text-[#BF2315] text-[10px]"
          role="alert"
          aria-live="assertive"
        >
          <img src={dangerIconRed} className="h-[10px] w-[10px]" alt="Error icon" />
          {helperText}
        </span>
      )}
    </div>
  );
};

export default SearchBar;
